import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IconButton from '@mui/material/IconButton';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import AirplayOutlinedIcon from '@mui/icons-material/AirplayOutlined';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AlertTitle from '@mui/material/AlertTitle';
import MuiAlert from '@mui/material/Alert';
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Iconstyle = {
    height: '40px',
    width: "40px",
    marginRight: '15px',
    color: '#fff'
}
const IconstyleNew = {
    height: '40px',
    width: "40px",
    marginRight: '15px',
    color: '#1976d2'
}

const QZTrayPage = (props) => {
    const { connectQZ, disconnectQZ } = props;
    const qzState = useSelector(state => state.qz);
    return (<>
        <Card sx={{ minWidth: 1000, boxShadow: 'unset' }} className="sc--cardhead--details">
            <CardHeader title='Billing' className="sc--cardhead--details" />
            <Divider />
            <CardContent>
                <Grid container style={{ justifyContent: 'center' }} spacing={1}>
                    {qzState.is_active &&
                        <Grid item xs={12} md={8}>
                            <Card sx={{ margin: '20px 0' }} className="sc--cardhead--details sc-custom-card">
                            <CardHeader
                                sx={{ backgroundColor: 'success.main', color: 'white' }}
                                avatar={
                                <LocalPrintshopIcon sx={Iconstyle} />
                                }
                                title={ <span style={{ color: 'white' }}>{"QZ Mode" + (qzState.printer != "" ? " (" + qzState.printer : "") + (qzState.queue_count && qzState.queue_count >= 0 ? " - " + qzState.queue_count + ")" : "") + (qzState.printer != "" && qzState.queue_count <= 0 ? ")" : "")}</span>}
                                action={
                                <Button variant="outlined" size="small" sx={{ color: 'white', borderColor: 'white', position:"relative",top:"10px" }} onClick={() => disconnectQZ()}>
                                    Switch to Browser Mode
                                </Button>
                                }
                            />
                            <Divider />
                            </Card>
                        </Grid>
                    }

                    {!qzState.is_active &&
                        <Grid item xs={12} md={8}>
                            <Card sx={{ margin: '20px 0' }} className="sc--cardhead--details sc-custom-card">
                            <CardHeader
                                sx={{ backgroundColor: 'info.main', color: 'white' }}
                                avatar={
                                <LocalPrintshopIcon sx={Iconstyle} />
                                }
                                title={
                                    <span style={{ color: 'white' }}>
                                        Browser Mode
                                    </span>
                                }
                                action={
                                <Button variant="outlined" size="small" sx={{ color: 'white', borderColor: 'white', position:"relative",top:"10px" }} onClick={() => connectQZ()}>
                                    {qzState.progress ? "Switching..." : "Switch to QZ Mode"}
                                </Button>
                                }
                            />
                            <Divider />
                            </Card>
                        </Grid>
                    }
                    <Grid item xs={12} md={8} >
                        <a href="https://qz.io/download/" target="_blank">
                            <Card sx={{ margin: '20px 0' }} className="sc--cardhead--details sc-custom-card">
                                <CardHeader
                                    avatar={
                                        <AirplayOutlinedIcon sx={IconstyleNew} />
                                    }
                                    title="QZTray Download"
                                    action={
                                        <div>
                                            <IconButton>
                                                <FileDownloadOutlinedIcon />
                                            </IconButton>
                                        </div>
                                    }
                                />
                                <Divider />
                            </Card>
                        </a>
                    </Grid>
                </Grid>
            </CardContent>
        </Card >
    </>
    )
}
export default QZTrayPage;
